import { HttpClient } from '@/shared/lib/http-client';

export const createWithdrawalRequest = async ({ userId, amount, amountActual, comment, recipientData }) => {
  const response = await HttpClient.post('/withdrawal-requests', {
    user_id: userId,
    amount: amount,
    amount_actual: amountActual,
    comment: comment,
    data: recipientData,
  });

  return response.data;
};
